function Page() {
  return (
    <article id="d53883ee-2440-48ec-9170-75c44f2acce4" className="page sans">
      <header>
        <h1 className="page-title">이용약관</h1>
        <p className="page-description"></p>
      </header>
      <div className="page-body">
        <p id="0f1fe63a-71dc-4b63-8348-72a3a7bc306c" className="">
          이용약관
        </p>
        <p id="b485985d-4f67-454d-bdfe-6a34e49537f4" className="">
          제1조 (목적)
        </p>
        <p id="2637261c-16cc-42a1-9dd5-42d224474090" className="">
          이 약관은 알파베이스 주식회사(이하 “회사”)가 제공하는 둥둥 및 관련
          서비스를 이용함에 있어 회사와 회원간의 권리, 의무 및 책임사항과 절차
          등을 정하기 위해 만들어졌습니다.
        </p>
        <p id="1dcc3ca1-8101-42d9-acda-815dc33e89c5" className="">
          제2조 (정의)
        </p>
        <p id="24de5eb4-2f7a-4512-a18e-a0e99c3d0814" className="">
          이 약관에서는 용어를 다음과 같이 정의하여 사용합니다.
        </p>
        <p id="e3595334-25a4-4b1c-9b53-4888402273bb" className="">
          “서비스”란 회원의 단말기(모바일, 태블릿PC 등 각종 유무선 장치를
          포함)를 통하여 회사가 제공하는 둥둥 및 관련 서비스 일체를 말합니다.
        </p>
        <p id="8ffeec17-5ca8-40a0-9795-e844b6880205" className="">
          “회원”이란 서비스에 접속하여 이 약관에 따라 회사와 이용계약을
          체결함으로써 서비스를 이용하는 고객 여러분을 말합니다.
        </p>
        <p id="5a20e209-1e26-49c7-b45c-40ec1aa0132d" className="">
          “아이디”란 회원의 식별과 서비스 제공을 위하여 회원이 정하고 회사가
          승인한 문자와 숫자의 조합입니다.
        </p>
        <p id="f6f60170-eb29-4c23-b011-3f210263ce30" className="">
          “캐시”란 제12조에 따라 회원이 일정한 행위를 마친 때에 시스템에
          적립되는 서비스 상의 데이터입니다.
        </p>
        <p id="2e86fd9a-216b-4387-8e2e-c7dffda61739" className="">
          “제휴컨텐츠”란 회사가 외부 업체와의 제휴를 통하여 회원에게 제공하는 유
          무상의 컨텐츠를 말합니다.
        </p>
        <p id="abe2702f-ce07-4c66-be82-ac4cecb475a1" className="">
          제3조 (약관의 게시와 개정)
        </p>
        <p id="03eb0011-a910-4347-b311-6d5f5cc48353" className="">
          이 약관은 회원이 쉽게 알 수 있도록 앱 공지사항 및 웹사이트의
          초기화면에 게시합니다.
        </p>
        <p id="e0701551-d60a-43cb-acb7-1bc73bc94b06" className="">
          회사는 필요에 따라 “약관의규제에관한법률”,
          “정보통신망이용촉진및정보보호등에관한법률” 등 관련 법령을 위반하지
          않는 범위 내에서 이 약관을 개정할 수 있습니다.
        </p>
        <p id="ab60c0af-a910-493b-83e5-13ea72474a1b" className="">
          회사가 약관을 개정하는 경우 적용일자 및 개정사항을 명시하여 적용일
          14일 전에 웹사이트 기타 공지사항 게시판 또는 이메일을 통해 공지합니다.
        </p>
        <p id="2612670a-4edc-45d5-b1ff-216980e24615" className="">
          공지일로부터 14일 이내에 회원이 명시적으로 거부하지 않는 경우 개정
          약관에 동의하신 것으로 봅니다.
        </p>
        <p id="98772c0f-a7ef-49ad-b540-4f64c1acceba" className="">
          회원이 개정에 동의하지 않는다는 의사를 표시한 경우 회사는 개정된
          약관을 적용할 수 없으며, 회원은 개정 약관의 효력 발생일부터 서비스를
          이용하실 수 없습니다.
        </p>
        <p id="bdcb3611-a4c5-4fc6-8f33-c6d5c79df37a" className="">
          제4조 (약관의 해석)
        </p>
        <p id="38b05969-e247-45c2-b647-964c5b71d6f7" className="">
          이 약관에서 정하지 않은 사항이나 해석에 대하여는 관련법령 또는
          상관례에 따릅니다.
        </p>
        <p id="2412a3d0-8ef7-4978-b20e-dd10c058b54e" className="">
          회사는 둥둥 내부의 개별 서비스에 대해 별도의 이용약관 또는 정책(이하
          “별도약관”)을 둘 수 있으며, 그 내용이 이 약관과 충돌하는 경우 별도의
          약관이 우선하여 적용됩니다.
        </p>
        <p id="4eb27833-0b36-42c6-a39e-e13e851672d1" className="">
          제5조 (이용계약의 체결)
        </p>
        <p id="0ea8a42a-5301-4e61-a501-f165d6235731" className="">
          서비스 이용계약은 회원이 되고자 하는 사람(이하 “가입신청자”)이 약관에
          동의하고 가입을 신청한 다음 회사가 이를 수락함으로써 체결됩니다.
          필요한 경우 회사는 본인확인기관을통한 실명확인 및 본인인증을 요청할 수
          있습니다.
        </p>
        <p id="62e3c2b8-fba1-4720-8e67-87c6d7e027d0" className="">
          가입신청자는 가입신청 시 진실한 정보를 기재하여야 하며, 허위의 정보를
          기재함으로 인한 불이익 및 법적 책임은 가입신청자에게 있습니다.
        </p>
        <p id="db639bef-dc86-4d2b-a767-1f9152e1e0f3" className="">
          만 14세 미만은 회원이 될 수 없습니다.
        </p>
        <p id="663d672e-91ca-475b-9446-af4032b540b0" className="">
          가입신청자가 이전에 회원자격을 상실한 적이 있는 경우, 허위의 명의 또는
          타인의 명의를 이용한 경우, 기타 승낙이 불가능한 사유가 있는 경우
          승낙이 거부될 수 있습니다.
        </p>
        <p id="5f125dd9-1140-4072-93cd-9ac6f72273df" className="">
          회사는 서비스 관련설비의 여유 기타 기술상 또는 업무상의 이유로 승낙을
          유보할 수 있으며, 그 결과를 가입신청자에게 알려드립니다.
        </p>
        <p id="abf53316-f751-4692-a519-05280c5eef30" className="">
          제6조 (회원정보의 변경)
        </p>
        <p id="ad97821a-5e7a-4827-b518-09e3e57cd557" className="">
          회원은 서비스 내 마이페이지 화면을 통하여 본인의 개인정보를 열람하고
          수정할 수 있습니다. 단, 서비스 관리를 위하여 ID, 이메일 주소, 성별은
          수정할 수 없습니다.
        </p>
        <p id="5e848cef-e03c-4765-9bd7-20f105751429" className="">
          가입신청시에 기재한 회원정보에 변동이 생긴 경우 이를 수정하거나 회사에
          통지하여야 하며 미수정 또는 통지하지 않음으로 인한 불이익에 대하여
          회사는 책임지지 않습니다.
        </p>
        <p id="b481f79e-7439-4c6c-aeea-e0842962d2bd" className="">
          제7조 (서비스 내용)
        </p>
        <p id="2aa87e73-3a09-470d-a740-59fa0f00f73c" className="">
          둥둥 서비스는 PIP(멀티윈도우 중 Picture In Picture)를 띄워놓고
          구동시간 동안의 광고 노출을 통해 캐시를 쌓고 혜택을 얻을 수 있는
          리워드 애플리케이션입니다.
        </p>
        <p id="93ad0a1f-9e54-468e-9630-57ca1ec85cc5" className="">
          ① 회사가 회원에게 제공하는 둥둥 서비스의 기본 내용은 다음과 같습니다.
        </p>
        <ol
          type="1"
          id="b1709c3f-0c7b-4ebc-a00d-5c72029ed91d"
          className="numbered-list"
          //start="1"
        >
          <li>광고의 송출 : 광고이미지, 텍스트, 음향, 링크등의 제공</li>
        </ol>
        <ol
          type="1"
          id="3914f842-10d8-463d-a84f-e984beaabf9b"
          className="numbered-list"
          //start="2"
        >
          <li>캐시 적립 : 약관 제12조의 행위를 완료한 회원에 대한 캐시 적립</li>
        </ol>
        <p id="de8f5c1c-57c5-4ecd-935c-4b4473ef4c5b" className="">
          iii. 제휴컨텐츠 이용 : 회사가 제공하는 컨텐츠를 이용, 구매 가능
        </p>
        <ol
          type="1"
          id="3b9ff337-0737-4c11-b6b0-207fbff4c860"
          className="numbered-list"
          //start="1"
        >
          <li>
            이벤트 등 회사가 개발하거나 다른 회사와의 제휴를 통해 회원에게
            제공하는 기타의 서비스
          </li>
        </ol>
        <p id="54db0ce3-4b24-4cea-af22-075d5b44239f" className="">
          ② 회사는 서비스 웹사이트을 운영하며, 회원은 보다 상세한 서비스 내용을
          문의할 수 있습니다.
        </p>
        <p id="a4ea42cf-db87-429c-bfcb-a1c72a98364a" className="">
          ③ 회사는 타겟팅 광고서비스 특성상 광고주의 요구에 따라, 또는 관련법규
          준수를 위하여 일부 서비스를 이용할 수 있는 회원의 범위를 다르게 정할
          수 있습니다.
        </p>
        <p id="8dc5a379-ab6a-416f-9938-9fb28db34e69" className="">
          ④ 회사는 원활한 서비스 제공을 위하여 회원에게 이메일 또는 sms를 통한
          광고 및 서비스 관련 정보를 제공할 수 있으며, 원치 않는 경우 언제든지
          수신거부 할 수 있습니다.
        </p>
        <p id="27e4a59d-78ee-410d-afab-3f3354620db9" className="">
          제8조 (서비스의 변경)
        </p>
        <p id="003b5a21-6c3d-4541-8490-70af3aa45aa7" className="">
          회사는 운영상, 기술상의 필요에 따라 제공하는 서비스의 전부 또는 일부를
          변경할 수 있으며, 이에 대하여 약관에 다른 규정이 없는 한 회원에게
          별도의 보상을 하지는 않습니다.
        </p>
        <p id="562c5d03-78da-430d-85c2-87089bb5aa0b" className="">
          서비스를 변경하는 경우 변경사유 및 일자, 변경내용을 변경 7일 전
          공지사항 게시판에 공지합니다. 단, 변경사유 또는 내용을 구체적으로
          공지하기 어려운 경우에는 그 이유를 밝힙니다.
        </p>
        <p id="1e49638c-9ae9-408c-991c-521a95893a46" className="">
          제9조 (서비스의일시 중단)
        </p>
        <p id="deabf3ca-ad9a-4ffc-bd07-945b80a5da30" className="">
          회사는 서비스관련설비 보수점검, 교체 및 고장, 통신두절 등 기술상
          업무상의 이유로 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우
          사전에 통지함을 원칙으로 하지만, 부득이한 사유가 있는 경우 사후에
          통지할 수 있습니다.
        </p>
        <p id="1ba676b3-fdb5-4664-86ac-2c7a1697e50e" className="">
          서비스 일시 중단은 이메일 또는 서비스 내 공지사항, 서비스 웹사이트에
          게시하는 방법으로 통지합니다.
        </p>
        <p id="58247433-1dbb-49ed-bdc2-7a98e1908782" className="">
          중단으로 인하여 회원이 손실을 입은 경우 회사는 통상적으로 예상 가능한
          범위 내에서 서비스 내 캐시 등으로 보상할 수 있습니다. 단, 천재지변 등
          불가항력에 의한 경우에는 보상하지 않습니다.
        </p>
        <p id="0e255ad5-43a0-41bf-8853-20f71fb98cfd" className="">
          제10조 (회원의 계약해지, 이용중지 요청 등)
        </p>
        <p id="fb1f6081-91e8-494f-94dd-c0df552901c0" className="">
          회원은 언제든지 서비스 내 계정관리 메뉴를 통하여 서비스 이용계약
          해지를 신청할 수 있으며 회사는 이를 즉시 처리합니다.
        </p>
        <p id="7f77360d-7856-4a3e-9e47-bfd10d78dc92" className="">
          위의 해지 시 잔여캐시는 즉시 소멸하며 다른 개인정보는 회사의
          “개인정보취급방침”에 따라 파기됩니다.
        </p>
        <p id="837b8382-034e-4b49-a7cb-5ba3fc940d88" className="">
          해지로 인하여 제휴컨텐츠 이용 및 현금전환 신청과 관련한 정보가
          삭제됨에 따라 회원에게 발생하는 손해에 대해 회사는 책임지지 않습니다.
        </p>
        <p id="86b74981-86d6-4263-ace3-be6b56c2102a" className="">
          회원은 이메일 통보 등 정해진 절차를 거쳐 서비스의 이용중지를 요청하실
          수 있습니다.
        </p>
        <p id="3b502c7f-708d-4115-813b-a8b38951acc7" className="">
          제11조 (회사의 계약해지, 이용제한 등)
        </p>
        <p id="7cd5bbe6-a9c1-42c0-818c-299eb4c4432b" className="">
          회사는 다음의 경우 사전통보 없이 해당 회원과의 이용계약을해지하여 회원
          자격을 상실시킬 수 있습니다.
        </p>
        <ol
          type="1"
          id="440dd124-7a22-4565-b1cb-26377f7479d0"
          className="numbered-list"
          //start="1"
        >
          <li>회원이 사망한 경우</li>
        </ol>
        <ol
          type="1"
          id="ce05f9bf-e580-4124-8ef5-2e89b8202789"
          className="numbered-list"
          //start="2"
        >
          <li>타인의 개인정보 또는 모바일 기기를 도용한 경우</li>
        </ol>
        <p id="4f7191f3-8ab8-47d4-9051-a2097afe97d9" className="">
          iii. 회원이 가입시 작성한 개인정보가 허위임이 밝혀진 경우
        </p>
        <ol
          type="1"
          id="430d7352-7bd2-4eda-97fa-b2dc365247eb"
          className="numbered-list"
          //start="1"
        >
          <li>캐시를 부정한 방법으로 적립하거나 사용한 경우</li>
        </ol>
        <ol
          type="1"
          id="b67a0972-7238-4db0-9f6e-67cf7098a355"
          className="numbered-list"
          //start="2"
        >
          <li>
            다른 회원의 서비스 이용을 방해하는 등 전자거래질서를 위협하는 경우
          </li>
        </ol>
        <ol
          type="1"
          id="195ca372-5bed-4182-aea5-2448a9eca302"
          className="numbered-list"
          //start="3"
        >
          <li>서비스 외에서 회사, 운영자, 임직원 등을 사칭하는 경우</li>
        </ol>
        <p id="e45e37ce-f9ac-483b-a3dc-82a53eb44325" className="">
          vii. 무단으로 회사의 클라이언트 프로그램을 변경하거나 서버를
          해킹하는등 시스템을 위협한 경우
        </p>
        <p id="33abfb39-2b7a-4c4f-9e57-f7afa9227b05" className="">
          viii. 허위사실 유포, 위계기타 방법으로 회사의 명예 또는 신용을
          훼손하거나 업무를 방해한 경우
        </p>
        <ol
          type="1"
          id="fc3fa44e-55db-4040-8033-8c4bfdedc4ef"
          className="numbered-list"
          //start="1"
        >
          <li>서비스에 관한 스팸성 홍보 활동을 하는 경우</li>
        </ol>
        <ol
          type="1"
          id="c12b5f3e-3a73-4ca3-8b56-a2fa0898aece"
          className="numbered-list"
          //start="2"
        >
          <li>기타 본 약관상의 의무 또는 법령에 위반되는 행위를 한 경우</li>
        </ol>
        <p id="c383a6ca-634c-43e8-a367-120a0733bf4a" className="">
          위 i호의 사유로자격상실 통보를 받은 회원의 캐시는 통보일로부터
          7일(잔여캐시해소기간) 이내에 제휴컨텐츠 구매에 사용될 수
          있습니다.해소기간 경과 후 잔여캐시는 소멸됩니다.
        </p>
        <p id="35282e7e-1465-46a8-847c-28b81a2303ac" className="">
          위 ii호부터 x호의 사유로 자격상실 통보를 받은 회원의 캐시는 통보 즉시
          소멸되고, 회원은 이의를 제기할 수 없습니다.
        </p>
        <p id="40b68edb-af30-441c-b8ba-940dc83eac90" className="">
          회사는 위의 사유가 있는 경우 자격상실 대신 이용의 제한을 가할 수
          있습니다.
        </p>
        <p id="e11ef521-50f5-44d0-80df-7d44c517705b" className="">
          제12조 (캐시 적립)
        </p>
        <p id="d282845b-4902-467b-887f-04c9317fb3df" className="">
          회사가 회원에게 제공하는 캐시 적립의 경로는 다음과 같습니다.
        </p>
        <ol
          type="1"
          id="2f4e7e0e-3940-4fbc-b723-0d495ca47b7f"
          className="numbered-list"
          //start="1"
        >
          <li>PIP화면의 단위시간을 충족하여 캐시받기를 완료한 경우</li>
        </ol>
        <ol
          type="1"
          id="26331947-9ada-4ceb-8f4e-fb87f89a8106"
          className="numbered-list"
          //start="2"
        >
          <li>그 외 회사가 새로운 방식으로 캐시 적립을 정한 경우</li>
        </ol>
        <p id="f90878c3-1bdc-417e-a96c-adf088eef0ca" className="">
          적립된 캐시 내역은 서비스 내 마이페이지 화면에서 확인하실수 있습니다.
        </p>
        <p id="c97b9a2e-62ae-47d6-9e10-8b28610de01e" className="">
          서버에 입력된 적립액과 클라이언트 상의 적립액 간에 차이가 나는 경우
          항상 서버의 수치를 기준으로 하며, 서버와 클라이언트의 비동기화로 인한
          적립금 차이는 정정이 불가능합니다.
        </p>
        <p id="78e21bc5-7a30-4bda-9118-52d175ae6d30" className="">
          캐시 적립과 관련하여 발생하는 제세공과금은 회원의 부담으로합니다.
        </p>
        <p id="b5a05fd7-f69d-44f2-8d43-50e05f492d30" className="">
          캐시는 양도, 상속, 대여, 담보의 목적으로 될 수 없습니다. 다만 회사가
          인정하는 경우 예외로 합니다.
        </p>
        <p id="46325e2a-7620-4c62-9964-a92cf27c7adb" className="">
          캐시 적립과 관련하여 제약사항은 다음과 같습니다.
        </p>
        <ol
          type="1"
          id="8e13427a-735d-46a1-aa8f-0f2c43e2ac0a"
          className="numbered-list"
          //start="1"
        >
          <li>하루 총량의 제한</li>
        </ol>
        <p id="592614ab-d90a-4ef7-b8ff-894bc594aefc" className="">
          하루 적립할 수 있는 캐시의 제한이 있을 수 있으며 그 양은 회사가 앱 내
          공지합니다.
        </p>
        <p id="50e7c58e-d8ea-48e1-b5f8-c0c08424ceb1" className="">
          상품에 따라 혹은 내부사정에 의해 지급되는 캐시는 변경 될 수 있습니다.
        </p>
        <p id="6b2bce0e-9f5a-4ab7-96a6-7722779a2fbd" className="">
          제13조 (제휴컨텐츠의이용)
        </p>
        <p id="ba39aaee-9746-4820-a7d4-e4c8d6bfc591" className="">
          회원은 적립된 캐시를 이용하여 서비스 내 제휴된 다양한 컨텐츠를 이용,
          구매하실 수 있습니다.
        </p>
        <p id="616b709d-e754-485f-a047-f2b40c2ea6cc" className="">
          제휴컨텐츠의 내용은 다른 회사와의 협의상황에 따라 변경될수 있습니다.
          제휴컨텐츠의 이용, 구매금액은 제휴처로부터의 공급금액, 지급 수수료,
          운영비용 등을 고려하여 산정이 되므로, 기존 판매가와 다를 수 있습니다.
        </p>
        <p id="6fbd74d8-62d6-410b-8f6d-0b99b0ea3ea4" className="">
          커피, 편의점등 현장에서 사용되는 제휴컨텐츠의 경우 회사가 회원의
          모바일기기로 해당 바코드를 전송함으로써 적법하게 이행을 완료한 것으로
          봅니다.
        </p>
        <p id="048b2b60-dbce-4964-95d2-576aa0d53579" className="">
          서비스 내에서 구매하신 쿠폰을 회원의 단순 변심으로 환불이 불가능
          합니다.
        </p>
        <p id="9d82b5f6-3712-4f10-8b89-ba0c2ac1c4e8" className="">
          제휴컨텐츠 이용과 관련한 분쟁에서 명시적인 책임소재가 제휴된 업체 측에
          있을 경우, 회사는 책임을 지지 않습니다.
        </p>
        <p id="9f4e712a-24e7-4660-9599-acae28580dab" className="">
          제14조 (캐시의정정, 취소 및 소멸)
        </p>
        <p id="9bf8525d-5e0f-4f2b-846f-51df397d3749" className="">
          캐시 적립에 오류가 발생한 경우 회원은 오류 발생일로부터 30일 이내에
          회사에 정정요구를 할 수 있으며, 회사는 정당한 요구임이 확인된 경우
          정정요구일로부터 30일 이내에 정정하여야 합니다.
        </p>
        <p id="b8b57438-7291-4fac-9651-1aceee727212" className="">
          클라이언트 변경, 해킹, 매크로 등 부정한 방법으로 광고를 시청하지
          않거나 시청한 광고 이상으로 캐시를 적립하신 경우, 부정적립이 되어 그
          캐시는 0으로 정정됩니다.
        </p>
        <p id="5f7e2c41-02f6-4879-abdc-011d1e2d3e7f" className="">
          회사와 광고주간의 거래과정에서 광고주의 파산, 부도 등 광고료의 지급이
          불가능해진 경우 회사는 당해 광고에 관해 적립된 캐시를 취소할 수
          있으며, 이에 대한 책임은 광고주에게 있습니다. 이 경우 회사는 취소된
          캐시의 10% 이하의 범위에서 회원에게 보상 캐시를 제공할 수 있습니다.
        </p>
        <p id="8b5cc9df-ca2a-4654-9810-b64c416d9c3b" className="">
          적립된 날로부터 12개월간 사용되지 않은 캐시는 차례로 소멸됩니다.
        </p>
        <p id="6e85a5a6-48d3-4c65-9591-fde15228131b" className="">
          캐시의 적립 또는 사용이 없는 비활성화 상태가 3개월 이상 계속된 회원의
          캐시는 소멸될 수 있습니다.
        </p>
        <p id="457775c1-4abc-48d2-b581-c7b32ce8317d" className="">
          제15조 (회원ID 및 비밀번호)
        </p>
        <p id="edb8a003-8526-4f41-830f-497561dc5d28" className="">
          회원ID와 비밀번호에관한 관리책임은 회원 본인에게 있으며, 회원은
          제3자에게자신의 ID및 비밀번호를 알려주거나 이용하게 해서는 안됩니다.
        </p>
        <p id="5c28ad1d-aedb-45bb-b781-2226d0e4a2e7" className="">
          회원이 자신의 ID 또는비밀번호를 도난 당하거나 제3자가 사용하고 있음을
          인지한 경우 즉시 회사에 통지하고 회사의 안내를 따라야합니다.
        </p>
        <p id="0238f9ae-76f7-4f50-bb10-24184345fb23" className="">
          제2항의 경우 회사에 통지하지 않거나, 안내에 따르지 않아 발생한
          불이익에 대하여 회사는 책임지지 않습니다.
        </p>
        <p id="a08743c4-6c59-4eff-9369-ad4eae9da2a1" className="">
          제16조 (광고ID와 IMEI값의 수집 및 연동)
        </p>
        <p id="97f6d938-b566-4bce-a101-c3843b5a7336" className="">
          구글플레이 4.0버전에서 도입된 ‘Android 광고 ID사용정책’에 따라 회사는
          광고ID를 사용하고, 부정이용방지 및 캐시제공을 위하여 광고ID와 회원의
          IMEI값을 연동합니다.
        </p>
        <p id="8007602d-7ab5-43e2-87ba-2b054a4fc546" className="">
          제17조 (회사의의무)
        </p>
        <p id="22f7f547-130c-424f-9e29-2a6e4e6115ef" className="">
          회사는 관련 법령 또는 이 약관을 위반하지 않으며, 계속적이고 안정적으로
          서비스를 제공하기 위하여 최선을 다합니다.
        </p>
        <p id="2bf1ccb4-71b3-4642-adeb-87a90dbd3a37" className="">
          회사는 신용정보를 포함한 회원의 개인정보 보호를 위하여 보안시스템을
          갖추어야 하며 개인정보취급방침을 공시하고 준수하겠습니다.
        </p>
        <p id="5e1927c0-0445-4b48-b78b-4aea7a34970a" className="">
          회사는 서비스 이용과 관련한 회원의 의견이나 불만사항 등이 정당하다고
          인정할 경우 이를 처리하여야 합니다. 처리된 결과는 게시판 또는 이메일을
          통해 회원에게 통보합니다.
        </p>
        <p id="3c4a2ac2-3730-4e3c-9a95-321d9ca70dc0" className="">
          제18조 (회원의 의무)
        </p>
        <p id="4e86205f-7d26-4357-a3a9-180955ec7909" className="">
          회원은 서비스 이용과 관련하여 다음의 행위를 하여서는 안됩니다.
        </p>
        <ol
          type="1"
          id="1224db5c-159c-48fe-90a9-5055a129c38a"
          className="numbered-list"
          //start="1"
        >
          <li>서비스 이용 관련 제반 신청 및 변경행위 시 허위내용의등록</li>
        </ol>
        <ol
          type="1"
          id="30df9b47-7b2c-4fa7-b853-bb595d36dbf8"
          className="numbered-list"
          //start="2"
        >
          <li>서비스 내 게시된 각종 정보의 무단 변경, 삭제 등 훼손</li>
        </ol>
        <p id="0868a201-9310-4556-b9c6-b716b2283d40" className="">
          iii. 일체의 가공행위를 통해 서비스를 분해, 변경, 모방하는 행위
        </p>
        <ol
          type="1"
          id="231c8858-7cee-4009-9988-145c968eaba0"
          className="numbered-list"
          //start="1"
        >
          <li>회사 기타 제3자의 지적재산권을 포함하여 권리를 침해하는 행위</li>
        </ol>
        <ol
          type="1"
          id="aa7bbbfe-8bd5-48dd-8ef2-6489f950d29f"
          className="numbered-list"
          //start="2"
        >
          <li>다른 회원의 개인정보 수집하거나 명예를 손상하는 행위</li>
        </ol>
        <ol
          type="1"
          id="ebd816a4-0121-4ba3-acee-7f1f3da62689"
          className="numbered-list"
          //start="3"
        >
          <li>
            회사의 동의 없이 광고를 전송하거나 외설, 폭력적인 정보 등을 노출하는
            행위
          </li>
        </ol>
        <p id="27977f99-e4c2-46b0-9c4b-474dc3b370f2" className="">
          vii. 기타 약관상의 의무를 불이행하는 행위
        </p>
        <p id="4601bcfe-b3c2-4f77-b8ab-d874aeb17c53" className="">
          viii. 기타 불법, 부당한행위
        </p>
        <p id="4b661689-4630-4947-b724-5bb188e864d8" className="">
          제 19조 (게시물의 관리 운영**)**
        </p>
        <p id="69335d5a-005e-48de-9cfc-279a4b104ba9" className="">
          회원이 작성한 게시물에 대한 모든 권리 및 책임은 이를 게시한 회원에게
          있으며, 회사는 회원이 게시하거나 등록하는 서비스의 내용물이 다음 각
          항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있고, 이에
          대하여 회사는 어떠한 책임도 지지 않습니다.
        </p>
        <ol
          type="1"
          id="61e934d7-fcbd-43d6-9e96-c4813cb309a8"
          className="numbered-list"
          //start="1"
        >
          <li>
            본 서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고
            판단되는 게시물을 게시한 경우
          </li>
        </ol>
        <ol
          type="1"
          id="8051dd0d-5e39-4469-a604-e0c7b935705f"
          className="numbered-list"
          //start="2"
        >
          <li>
            회사의 원활한 서비스 제공을 방해하거나 서비스 성격에 부합하지 않는
            정보의 경우
          </li>
        </ol>
        <p id="8032dbb0-ab38-4aa7-93ad-ec4dcbd018de" className="">
          iii. 공공질서 및 미풍양속에 위반되는 내용인 경우
        </p>
        <ol
          type="1"
          id="a49d0db1-1f14-425c-8f83-163369c9f836"
          className="numbered-list"
          //start="1"
        >
          <li>
            다른 회원 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키고
            피해를 주는 내용인 경우
          </li>
        </ol>
        <ol
          type="1"
          id="f11c8d9e-e362-4ede-a460-2290cbf7d00b"
          className="numbered-list"
          //start="2"
        >
          <li>
            제 3자의 저작권, 지적 재산권, 초상권 등 권리를 침해하는 내용인 경우
          </li>
        </ol>
        <ol
          type="1"
          id="0b375170-bac4-40ee-8319-620c2f7e2f77"
          className="numbered-list"
          //start="3"
        >
          <li>해당 상품 및 콘텐츠 내용과 관련 없는 경우</li>
        </ol>
        <p id="31b39a9f-b1ea-4653-abe0-892c3547db10" className="">
          vii. 타사의 광고, 홍보 등의 상업적인 내용인 경우
        </p>
        <p id="5247a3ab-9a25-4e45-b4a2-41f5b8f5e2f0" className="">
          viii. 범죄적 행위에 결부된다고 인정되는 내용인 경우
        </p>
        <ol
          type="1"
          id="036f5e7e-b14c-451e-8860-c609d72efcd0"
          className="numbered-list"
          //start="1"
        >
          <li>기타 관계 법령에 위배되는 경우</li>
        </ol>
        <p id="2d83a2ef-8944-4b71-af0e-f7a5e2497c41" className="">
          회원이 작성한 게시물에 회사가 지정한 부적절한 단어가 포함된 경우,
          별도의 안내없이 게시물의 게제가 거절 될 수 있습니다.
        </p>
        <p id="2382be49-cabc-4c6b-9604-c82f4e492e8c" className="">
          회원의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의
          책임은 전적으로 회원이 부담하여야 합니다.
        </p>
        <p id="a88a4f52-871c-48d2-8ad8-2ce6f4319af4" className="">
          제 20조 (게시물의 관리 및 임시조치)
        </p>
        <p id="9999a49c-0021-4eff-bfaf-d0adfc873ed2" className="">
          회원의 게시물 등이 관련 법령에 위반되는 내용을 포함하는 경우, 회사는
          해당 관련 법령이나 적법한 권리자의 요청에 따라 해당 게시물 등에 대한
          게시중단 및 삭제 등의 조치를 취할 수 있습니다.
        </p>
        <p id="216403bc-1767-40fd-afc4-fcdcdc0137ef" className="">
          회사는 게시물 등에 회사의 서비스 운영정책에 위반되는 사유가 있는
          것으로 확인된 경우, 운영정책에 따라 해당 게시물에 대해 조치를 취할 수
          있습니다.
        </p>
        <p id="1df579ba-0569-42b4-a33d-c1a5a91e6e68" className="">
          회사는 3회 이상 신고 접수 된 게시물에 대하여 영구 삭제 조치를 취할 수
          있습니다.
        </p>
        <p id="253d15dd-5eaa-4109-bad9-0e3a51feb2ba" className="">
          정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
          &quot;정보통신망법&quot;)의 규정에 의해 다른 회원의 공개된 게시물 등이
          본인의 사생활을 침해하거나 명예를 훼손하는 등 권리를 침해 받은 회원
          또는 제3자(이하 &quot;삭제 등 신청인&quot;)는 그 침해사실을 소명하여
          회사에 해당 게시물 등의 삭제 또는 반박 내용의 게재를 요청할 수
          있습니다. 이 경우 회사는 해당 게시물 등의 권리 침해 여부를 판단할 수
          없거나 당사자 간의 다툼이 예상되는 경우 해당 게시물 등에 대한 접근을
          임시적으로 차단하는 조치(이하 &quot;임시조치&quot;)를 최장 30일까지
          취합니다.
        </p>
        <p id="34d365cb-c31c-4be9-a4a5-936f0b653acd" className="">
          전항에 의해 본인의 게시물 등이 임시조치된 회원(이하
          &quot;게시자&quot;)은 임시조치기간 중 회사에 해당 게시물 등을 복원해
          줄 것을 요청(이하 &quot;재게시 청구&quot;)할 수 있으며, 회사는
          임시조치된 게시물의 명예훼손 등 판단에 대한 방송통신심의위원회 심의
          요청에 대한 게시자 및 삭제 등 신청인의 동의가 있는 경우 게시자 및 삭제
          등 신청인을 대리하여 이를 요청하고 동의가 없는 경우 회사가 이를
          판단하여 게시물 등의 복원 여부를 결정합니다. 게시자의 재게시 청구가
          있는 경우 임시조치 기간 내에 방송통신심의위원회 또는 회사의 결정이
          있으면 그 결정에 따르고 그 결정이 임시조치 기간 내에 있지 않는 경우
          해당 게시물 등은 임시조치 만료일 이후 복원됩니다. 재게시 청구가 없는
          경우 해당 게시물 등은 임시조치 기간 만료 이후 삭제됩니다.
        </p>
        <p id="19220e40-cf0c-463c-8e1f-f483ea7653f3" className="">
          회사는 서비스 내에 게시된 게시물 등이 사생활 침해 또는 명예훼손 등
          제3자의 권리를 침해한다고 인정하는 경우 회원 또는 제3자의 신고가 없는
          경우에도 임시조치를 취할 수 있습니다.
        </p>
        <p id="f3c3de5c-a088-47c2-94bc-04a4ad23d53e" className="">
          회원의 게시물 등으로 인한 법률상 이익 침해를 근거로, 다른 회원 또는
          제3자가 회원 또는 회사를 대상으로 하여 민·형사상의 법적조치(예:
          형사고소, 가처분신청∙손해배상청구등민사소송의제기)를 취하는 경우,
          회사는 동법적조치의 결과인 법원의 확정판결이 있을 때 까지 관련게시물
          등에 대한 접근을 잠정적으로 제한할 수 있습니다. 게시물 등의 접근제한과
          관련한 법적조치의 소명, 법원의 확정판결에 대한 소명책임은 게시물 등에
          대한 조치를 요청하는자가 부담합니다.
        </p>
        <p id="4a7f6df4-3b5a-479a-9206-9a24919c8a1d" className="">
          제21조 (저작권의귀속 및 이용제한)
        </p>
        <p id="4ef7b10b-4d4a-43b8-91f3-563bcf72f79f" className="">
          회사의 상표, 로고, 제공하는 서비스 및 광고내용에 관한 지적재산권 등의
          권리는 회사에 귀속합니다.
        </p>
        <p id="aae0aa52-b432-4410-8cc3-a844d5161cd6" className="">
          회원은 서비스를 이용함으로써 얻은 정보를 회사의 사전승낙없이 복제,
          송신, 출판,배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나
          제3자에게 이용하도록 하여서는 안됩니다.
        </p>
        <p id="fd15d408-b08a-489b-957a-1d10dc3c0959" className="">
          제22조 (서비스관련 분쟁해결)
        </p>
        <p id="5bea5e82-73fc-40ef-86f6-865e961ac10a" className="">
          회사는 서비스 이용과 관련한 회원의 의견이나 불만사항을 신속하게
          처리합니다. 단, 신속한 처리가 곤란한 경우에는그 사유와 처리일정을
          통보하여 드립니다.
        </p>
        <p id="b5489069-51ac-4b6a-9578-548bf69f49df" className="">
          회사와 회원간에 발생한 분쟁은 전자거래기본법에 의해 설치된
          전자거래분쟁 조정위원회의 조정절차에 의해 해결할 수 있습니다.
        </p>
        <p id="a327c7f0-eea6-4273-abcd-443b48c67090" className="">
          제23조 (서비스의종료)
        </p>
        <p id="81275ea5-c615-4190-aa59-677e3860f339" className="">
          회사는 서비스를 종료하고자 하는 날로부터 3개월 이전에 이 약관 제3조
          3항의 방법으로 회원에게 알립니다.
        </p>
        <p id="5b43f94b-8f42-4858-8e02-92fd61c8d254" className="">
          서비스 종료통지일 현재 기 적립된 캐시는 서비스 종료일까지본 약관이
          정하는 바에 따라 소진하셔야 하며, 서비스 종료일 이후로는 자동 소멸되어
          회원은 캐시에 관한 권리를 주장하실 수 없습니다.
        </p>
        <p id="e031add7-4c71-42e7-8e5b-de03cbf1ab02" className="">
          종료 통지일로부터 서비스 종료일까지 서비스의 일부가 제한될수 있습니다.
        </p>
        <p id="7b6a6b21-0afb-4d50-8a85-e829a816ffd9" className="">
          제24조 (준거법및 합의관할)
        </p>
        <p id="43e878e7-cdd1-4f12-94b6-9a506d017ded" className="">
          회사와 회원간에 제기된 법적 분쟁은 대한민국 법을 준거법으로합니다.
        </p>
        <p id="4f5ab6a0-89cf-41ba-9399-5596899d7f68" className="">
          회사와 회원간의 분쟁에 관한 소송은 서울중앙지방법원 또는 민사소송법
          상의 관할법원에 제소합니다. 제23조 (개인정보보호의무) 회사는 관련
          법령이 정하는 바에 따라서 회원 등록정보를 포함한 개인정보를 보호하기
          위하여 노력합니다. 이에 관해서는 관련 법령 및 회사의
          “개인정보취급방침”에 의하며, 회원이 늘 확인하실 수 있도록 웹사이트를
          통해 공시하고 있습니다.
        </p>
        <p id="f282c7b5-4adb-460a-af76-0703d875b5c6" className="">
          부칙
        </p>
        <p id="910c9e2d-6b8b-4d49-804b-27b7f075abe9" className="">
          이 약관은 2024년 01월 19일부터 적용됩니다.
        </p>
      </div>
    </article>
  );
}

export default Page;
